<script lang="ts">
	import { getGlobalSettings } from "../getGlobalSettings.js";
	import { getTenant } from "../getTenant.js";
	import { getTranslate } from "../utils/getTranslate.js";
	import translations from "./CookieReport.translations.json";

	const { COOKIES } = getGlobalSettings();

	const translate = getTranslate(translations);

	const tenant = getTenant();

	// Category headings rendered by the Cookie-Script report (in both locales) mapped to their descriptions
	const descriptions: Record<string, keyof typeof translations> = {
		"nezbytně nutné soubory": "necessary",
		"strictly necessary": "necessary",
		"výkonové soubory": "performance",
		performance: "performance",
		"soubory cílení": "targeting",
		targeting: "targeting",
		"funkční soubory": "functionality",
		functionality: "functionality",
	};

	let div: HTMLDivElement | undefined;

	$: {
		if (div !== undefined) {
			for (const h4 of div.querySelectorAll("h4")) {
				const content = h4.innerText.trim().replace(/\s+/gu, " ").toLowerCase();
				const key = descriptions[content];

				if (key !== undefined) {
					const paragraph = document.createElement("p");
					paragraph.textContent = translate(key);
					h4.after(paragraph);
				}
			}
		}
	}

	/* eslint-disable svelte/no-at-html-tags */
</script>

<div bind:this={div}>
	{@html `<script type="text/javascript" charset="UTF-8" data-cookiescriptreport="report" data-cs-lang="${tenant.locale}" src="//report.cookie-script.com/r/${COOKIES}.js"></script>`}
</div>

<style lang="postcss">
	div {
		@apply text-ltsecondary text-xs lg:text-base;
		contain: inline-size;

		:global(p) {
			@apply mb-3 lg:leading-[1.4rem];
		}

		:global(h4) {
			@apply text-ltprimary lg:text-md mb-2 mt-8 text-base font-medium uppercase tracking-wider;
		}

		:global(._CookieScriptReportPageTable) {
			@apply my-4 block max-w-[100cqw] overflow-auto;
		}

		:global(._CookieScriptReportPageTable table) {
			@apply text-2xs w-full border-collapse bg-white lg:text-xs;
		}

		:global(._CookieScriptReportPageTable th) {
			@apply bg-lttertiary-50 text-ltprimary p-3 text-left font-semibold uppercase tracking-wider first:rounded-l-[.65rem] last:rounded-r-[.65rem];
		}

		:global(._CookieScriptReportPageTable td) {
			@apply border-lttertiary-200 border-b p-3 text-left align-top;
		}

		:global(._CookieScriptReportPageCheckboxes) {
			@apply my-6 flex flex-wrap gap-x-6 gap-y-2;
		}

		:global(._CookieScriptReportPageCheckboxInput) {
			@apply accent-ltprimary-300 mr-2;
		}

		:global(._CookieScriptReportPageCheckboxText) {
			@apply text-ltsecondary text-xs font-medium lg:text-base;
		}

		:global(._CookieScriptReportPageSaveSettingButton) {
			@apply bg-ltprimary-300 hover:bg-ltprimary-100 font-roboto text-2xs block w-fit cursor-pointer rounded-full border-0 px-6 py-3 font-medium uppercase tracking-[0.075rem] text-white transition-all duration-300 lg:text-xs;
		}
	}
</style>
